<template>
  <div class="width100 margin-auto">
    <!-- 检索 -->
    <div class="backwhite">
      <div class="f16 width98 textalign-left dimensional">研发项目新增</div>
      <div class="pad-top20">
        <p class="textalign-left margin-top20 dimencont">项目信息</p>
        <div
          class="
            width98
            margin-top20
            pad-left10 pad-right10 pad-bot20
            flex-betweenwrap
          "
          style="background: #f6f7fb; border-radius: 3px"
        >
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10">项目名称</p>
            <el-input
              placeholder="请输入项目名称,如：一种摩托车消声器防锈剂"
              v-model="form.title"
              class="width100"
            ></el-input>
          </div>
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10">项目编号</p>
            <el-input
              placeholder="请输入项目编号，如:CS203000000"
              v-model="form.project_number"
              class="width100"
            ></el-input>
          </div>
          <div class="width100 margin-top20">
            <p class="textalign-left pad-bot10">技术分类</p>
            <el-input
              placeholder="请选择技术分类"
              v-model="form.ipc"
              class="width100"
              @focus="smallchange()"
            ></el-input>
          </div>
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10 flex-betweennowrap">
              <span>研发阶段</span>
              <span class="bluecolor" @click="dialogtabledealiy = true"
                >如何选择?</span
              >
            </p>
            <el-select
              v-model="form.progress"
              placeholder="请选择研发阶段"
              class="width100"
              :filterable="true"
            >
              <el-option label="---  请选择  ---" value=""></el-option>
              <el-option
                v-for="item in optionnature"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10">技术关键词</p>
            <el-input
              placeholder="请输入技术关键词"
              v-model="form.keyword"
              class="width100"
            ></el-input>
          </div>
        </div>
      </div>
      <div class="pad-top20">
        <p class="textalign-left dimencont">项目实施</p>
        <div
          class="
            width98
            margin-top20
            pad-left10 pad-right10 pad-bot20
            flex-betweenwrap
          "
          style="background: #f6f7fb; border-radius: 3px"
        >
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10">负责人</p>
            <el-select
              v-model="forms.nature"
              placeholder="请选择负责人"
              class="width100"
              allow-create
            >
              <el-option
                v-for="item in Responsible"
                :key="item.id"
                :label="item.user == null ? '' : item.user.realname"
                :value="item.user_id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10">承担部门</p>
            <el-input
              placeholder="请输入承担部门"
              v-model="forms.name"
              class="width100"
            ></el-input>
          </div>
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10">立项时间</p>
            <el-date-picker
              class="inputDeep"
              v-model="forms.date"
              type="date"
              placeholder="请选择立项时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 100%"
            ></el-date-picker>
          </div>
          <div class="width48 margin-top20">
            <p class="textalign-left pad-bot10">预计完成</p>
            <el-date-picker
              class="inputDeep"
              v-model="forms.enddate"
              type="date"
              placeholder="请选择预计完成时间"
              value-format="yyyy-MM-dd"
              :editable="false"
              style="width: 100%"
            ></el-date-picker>
          </div>
          <div class="width100 margin-top20">
            <p class="textalign-left pad-bot10">协作单位</p>
            <el-input
              placeholder="请输入协作单位"
              v-model="forms.numbers"
              class="width100"
            ></el-input>
          </div>
          <div class="width100 margin-top20">
            <p class="textalign-left pad-bot10">项目备注</p>
            <el-input
              placeholder="请输入项目备注"
              type="textarea"
              :autosize="autosize"
              v-model="forms.desc"
              class="width100"
            ></el-input>
          </div>
        </div>
      </div>
      <p class="determine pad-top20">
        <el-button @click="dialognull()">取 消</el-button>
        <el-button type="primary" @click="addproject()">确 定</el-button>
      </p>
    </div>
    <el-dialog
      title=""
      :visible.sync="dialogVisiblenull"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="25%"
      class="errorbox"
    >
      <p class="textalign-left f16">提示</p>
      <div class="textalign-left margin-top10">
        <span class="errormessage">{{ errormessage }}</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <span @click="dialogVisiblenull = false" class="errorbutton">
          确 定
        </span>
      </span>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="dialogtabledealiy"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left">研发活动研究阶段与开发阶段定义及特征</p>
      <table class="width100 margin-auto backwihte margin-top20 lineheight25">
        <tr class="borderleftnone hight40 f14">
          <th class="width10">研发阶段</th>
          <th class="borderleftnone width20">定义</th>
          <th class="borderleftnone width20">特征</th>
          <th class="borderleftnone width40">活动举例</th>
        </tr>
        <tr class="f14 textalign-center">
          <td class="borderf1 bordertopnone width5">研究阶段</td>
          <td class="table width20">
            为获取新的科学或技术知识并理解它们而进行的独创性的有计划凋查
          </td>
          <td class="table width20">
            研究阶段是探索性的，为进步开发活动进行资料及相关方面的准备，已进行的研究活动将来是否会转入开发、开发后是否会形成无形资产等均具有较大的不确定性
          </td>
          <td class="table width40">
            意在获取知识而进行的活动，研究成果或其他知识的应用研究、评价和最终选择，材料、设备、产品、工序系统或服务替代品的研究，新的或经改进的材料、设备、产品、工序系统或服务的可能替代品的配置、设计、评价和最终选择等
          </td>
        </tr>
        <tr class="f14 textalign-center">
          <td class="borderf1 bordertopnone width10">开发阶段</td>
          <td class="table width20">
            在进行商业性生产或使用前，将研究成果或其他知识应用于某项计划或设计，以生产出新的或具有实质性改进的材料、装置、产品等
          </td>
          <td class="table width20">
            已完成研究阶段的工作，在很人程度上具备了形成一项新产品或新技术的基本条件
          </td>
          <td class="table width40">
            生产前或使用前的原型和模型的设计、建造和测试，不具有商业性生产经济规模的试生产设施的设计、建造和运营等
          </td>
        </tr>
      </table>
      <p class="textalign-right margin-top20">
        <el-button @click="dialogtabledealiy = false">关 闭</el-button>
      </p>
    </el-dialog>
    <el-dialog
      title=""
      :visible.sync="ipcdilog"
      :close-on-click-modal="false"
      :show-close="true"
      :center="true"
      :modal="true"
      :modal-append-to-body="true"
      :append-to-body="true"
      width="50%"
    >
      <p class="textalign-left f18">项目分类</p>
      <div class="margin-top20">
        <el-tree
          class="isdisabled"
          :data="ipcdata"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :check-on-click-node="true"
          :check-strictly="true"
          :show-checkbox="checkbox"
          @check="treeCheck"
          @node-expand="nodeExpand"
          @node-collapse="nodeCollapse"
          node-key="title"
          ref="treeForm"
          :highlight-current="true"
        ></el-tree>
      </div>
      <p class="textalign-right margin-top20">
        <el-button type="primary" @click="ipctitle()">确 定</el-button>
        <el-button @click="ipcdilog = false">关 闭</el-button>
      </p>
    </el-dialog>
  </div>
</template>
<script>
import { designSave, patentleveldata } from "@/api/Center/Center.api";
import { bindstafflist } from "@/api/loader/loder.api";
import BUS from "@/BUS/BUS";
export default {
  data() {
    return {
      errormessage: "",
      dialogVisiblenull: false,
      dialogtabledealiy: false,
      ipcdilog: false,
      form: {
        title: "",
        progress: "",
        project_number: "",
        ipc: "",
        keyword: "",
      },
      forms: {
        name: "",
        numbers: "",
        date: "",
        enddate: "",
        nature: "",
        desc: "",
      },
      autosize: {
        minRows: 3,
        maxRows: 1000,
      },
      optionnature: [
        {
          value: 1,
          label: "研究阶段",
        },
        {
          value: 2,
          label: "开发阶段",
        },
      ],
      Responsible: [],
      ipcdata: [],
      defaultProps: {
        children: "sub",
        label: "detail",
      },
      checkbox: false,
    };
  },
  methods: {
    handleNodeClick(data, e, node) {
      data.sub = [{}];

      if (data.sub.length != 0) {
        patentleveldata({ pid: data.id }).then((res) => {
          if (res.data.code == 200) {
            data.sub = res.data.data;
            res.data.data.forEach((i) => {
              if (i.sub.length != 0) {
                i.disabled = true;
                this.checkbox = false;
              } else {
                this.checkbox = true;
                i.disabled = false;
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.form.ipc = data.title;
      }
    },

    treeCheck: function (node, list) {
      //node 该节点所对应的对象、list 树目前的选中状态对象
      //选中事件在选中后执行，当lis中有两个选中时，使用setCheckedKeys方法，选中一个节点

      this.form.ipc = node.title;
      if (list.checkedKeys.length == 2) {
        //单选实现
        this.$refs.treeForm.setCheckedKeys([node.title]);
      }
    },
    ipctitle() {
      this.ipcdilog = false;
    },
    nodeExpand(data, e, node) {
      data.sub = [{}];
      if (data.sub.length != 0) {
        patentleveldata({ pid: data.id }).then((res) => {
          if (res.data.code == 200) {
            data.sub = res.data.data;
            res.data.data.forEach((i) => {
              if (i.sub.length != 0) {
                i.disabled = true;
                this.checkbox = false;
              } else {
                this.checkbox = true;
                i.disabled = false;
              }
            });
          } else {
            this.dialogVisiblenull = true;
            this.errormessage = res.data.msg;
          }
        });
      } else {
        this.form.ipc = data.title;
      }
    },
    nodeCollapse(data) {
      // this.expandData.filter((item) => item !== data.guid);
    },

    addproject() {
      designSave({
        title: this.form.title,
        progress: this.form.progress, //1研究阶段 2开发阶段
        keyword: this.form.keyword,
        ipc: this.form.ipc,
        // industry: this.form.industry,
        // industry_small: this.form.industry_small,
        project_number: this.form.project_number,
        start_date: this.forms.date, //立项时间
        end_date: this.forms.enddate,
        research_dev_title: this.forms.name,
        cooperation: this.forms.numbers,
        manager: this.forms.nature, //负责人user_id
        remark: this.forms.desc,
        //"approval_time": "批准时间",
        //"finish_time": "结题时间",
      }).then((res) => {
        if (res.data.code == 200) {
          window.sessionStorage.setItem("centerNums", res.data.data.id);
          BUS.$emit("centerNums", res.data.data.id);

          this.$message({
            message: "新增成功",
            type: "success",
          });
          this.$router.push({
            path: "/development-Administration/Science-addPersonnel",
          });
          this.form.title = "";
          this.form.progress = "";
          this.form.project_number = "";
          this.form.keyword = "";
          this.ipcdata = [];
          this.form.ipc = "";
          this.form.ipc = "";
          this.forms.date = "";
          this.forms.name = "";
          this.forms.numbers = "";
          this.forms.nature = "";
          this.forms.desc = "";
        } else {
          this.dialogVisiblenull = true;
          this.errormessage = res.data.msg;
        }
      });
    },
    dialognull() {
      BUS.$emit("sciencepro", "null");
    },
    smallchange() {
      this.ipcdilog = true;
    },
  },
  created() {
    bindstafflist({ all: 1 }).then((res) => {
      if (res.data.code == 200) {
        this.Responsible = res.data.data;
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
    patentleveldata({ pid: 0 }).then((res) => {
      if (res.data.code == 200) {
        this.ipcdata = res.data.data;
        res.data.data.forEach((i) => {
          i.disabled = true;
          this.checkbox = false;
          i.sub = [{}];
        });
      } else {
        this.dialogVisiblenull = true;
        this.errormessage = res.data.msg;
      }
    });
  },
};
</script>
<style scoped>
.isdisabled >>> .is-disabled {
  display: none !important;
}
.isdisabled >>> .el-tree-node__content {
  display: flex;
  align-items: baseline;
  white-space: wrap;
  height: 100%;
  outline: 0;
  cursor: pointer;
  padding-top: 10px;
  padding-bottom: 10px;
}

.table {
  border: 1px solid #f1f1f1;
  border-left: none;
  border-top: none;
  padding: 5px 10px;
  text-align: left;
}

.borderleftnone {
  /* border-left: none; */
  background: #f1f1f1;
}
.bordertopnone {
  border-top: none;
}
.contquestion {
  position: relative;
  top: -32px;
  left: 145px;
  color: #409eff;
  font-size: 12px;
}
.questions {
  border-radius: 50%;
  padding: 0 5px 0 5px;
  margin: 0 5px 0 20px;
  height: 10px;
  background: #409eff;
  color: #fff;
}
.approvebtn {
  display: inline-block;
  width: 80px;
  height: 26px;
  line-height: 26px;
  border-radius: 4px;
  background-color: rgba(58, 126, 230, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 12px;
  text-align: center;
  margin: 5px 0 0 5px;
}
.determine {
  text-align: right;
}
.itemconten >>> .el-form-item__content {
  text-align: left;
}
.errorbox >>> .el-dialog__body {
  text-align: center;
}
.errorbox >>> .el-dialog {
  position: relative;
  top: 20%;
}
</style>